// import React, { useState, useEffect } from 'react';
// import * as Yup from 'yup';
// import {
//    Grid,
//    GridItem,
//    useColorModeValue,
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    ModalCloseButton,
//    ModalBody,
//    Button,
//    useToast,
//    Flex,
//    FormControl,
//    FormLabel,
//    Input,
//    InputGroup,
//    Text,
//    IconButton,
//    InputRightElement,
//    Divider,
//    useDisclosure,
// } from '@chakra-ui/react';
// import { useForm } from 'react-hook-form';
// import { yupResolver } from '@hookform/resolvers/yup';
// import { FaArrowRight } from 'react-icons/fa';
// import CompanyForm from './CompanyForm';
// // import CompanySetting from './CompanySetting';
// import { validateGST } from '../../../utils/util';

// const validationSchema = Yup.object().shape({
//    gst: Yup.string()
//       .min(15, 'Name must be at least 15 characters long')
//       // .matches(
//       //   /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
//       //   'Invalid GST number',
//       // )
//       .test('gst-valid', 'Invalid GST number', (value) => {
//          if (!value) return false;
//          return validateGST.isValid(value);
//       })
//       .optional(),
// });

// const CompanyWithGst = ({ isOpen, onClose }) => {
//    // const [errors, setErrors] = useState({});
//    const textColor = useColorModeValue('gray.800', 'white');
//    const btnRef = React.useRef();
//    const toast = useToast();
//    const [gstNo, setGstNO] = useState(null)
//    const [row, setRow] = useState({
//       gst: '',
//    });

//    const { isOpen: isOpenModal, onOpen: onOpenModal, onClose: onCloseModal } = useDisclosure();

//    const {
//       register,
//       handleSubmit,
//       formState: { errors },
//       reset,
//    } = useForm({
//       resolver: yupResolver(validationSchema),
//       defaultValues: {
//          gst: '',
//       },
//       mode: 'onChange',
//    });

//    const handleOnClose = () => {
//       localStorage.removeItem('gst');
//       onCloseModal();
//    };

//    const onSubmit = (data) => {
//       // setRow((prev) => ({ ...prev, ...data }));
//       // onCloseModal();
//       setGstNO(data.gst);
//       localStorage.setItem('gst', data.gst);
//       reset();
//       onClose();
//       onOpenModal();
//    };

//    return (
//       <>
//          <Modal isOpen={isOpen} onClose={onClose} size="4xl">
//             <ModalOverlay />
//             <ModalContent
//                bg={useColorModeValue('white', '#2d3748')}
//                color={useColorModeValue('gray.800', 'white')}
//                borderRadius="20px"
//                p={5}
//                boxShadow="lg">
//                <ModalHeader fontSize="20px" fontWeight="600" mb={4}>
//                   Create New Company
//                </ModalHeader>
//                <ModalCloseButton />
//                <ModalBody>
//                   <Grid
//                      // templateRows="repeat(2, 1fr)"
//                      // templateColumns="repeat(5, 1fr)"
//                      gap={4}>
//                      <form onSubmit={handleSubmit(onSubmit)}>
//                         <GridItem colSpan={5}>
//                            <FormControl mb="24px">
//                               <FormLabel display="flex" ms="4px" fontSize="sm" fontWeight="500" color={textColor}>
//                                  Provide your Company's GSTIN. We will fetch your Company's details automatically
//                               </FormLabel>

//                               <InputGroup size="md">
//                                  <Input
//                                     isRequired
//                                     variant="auth"
//                                     fontSize="sm"
//                                     name="gst"
//                                     placeholder="GSTIN"
//                                     size="lg"
//                                     type="text"
//                                     pr="4.5rem"
//                                     {...register('gst')}
//                                     sx={{ textTransform: 'uppercase' }}
//                                  />
//                                  <InputRightElement mx={2}>
//                                     <IconButton
//                                        colorScheme="blue"
//                                        ref={btnRef}
//                                        // onClick={() => handleOnOpen()}
//                                        icon={<FaArrowRight />}
//                                        mt={2.5}
//                                        mx={4}
//                                        type="submit"
//                                     />
//                                  </InputRightElement>
//                               </InputGroup>
//                               {errors.gst && (
//                                  <Text color="red.500" fontSize="sm" mt="2">
//                                     {errors?.gst?.message}
//                                  </Text>
//                               )}
//                            </FormControl>
//                         </GridItem>
//                      </form>
//                   </Grid>
//                   <Grid templateRows="repeat(2, 1fr)" templateColumns="repeat(5, 1fr)" gap={4}>
//                      <GridItem colSpan={5}>
//                         <Flex justifyContent="start" alignItems="center">
//                            <Divider orientation="horizontal" />
//                            <Text mx={3}>OR</Text>
//                            <Divider orientation="horizontal" />
//                         </Flex>
//                      </GridItem>
//                   </Grid>

//                   <Grid>
//                      <GridItem colSpan={5}>
//                         <Text mb={2}>You can setup Company without entering GSTIN too.</Text>
//                         <Flex justifyContent="center" alignContent="center">
//                            <Button
//                               variant="ghost"
//                               textColor="blue.500"
//                               onClick={() => {
//                                  onOpenModal();
//                                  onClose();
//                               }}
//                               type="button">
//                               SETUP WITHOUT GSTIN
//                            </Button>
//                         </Flex>
//                      </GridItem>
//                   </Grid>
//                </ModalBody>
//             </ModalContent>
//          </Modal>

//          <CompanyForm isOpen={isOpenModal} onClose={handleOnClose} isEditMode={false} currentRow={null} gstNo={gstNo} />
//       </>
//    );
// };

// export default CompanyWithGst;

import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import {
   Grid,
   GridItem,
   useColorModeValue,
   useColorMode,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   Button,
   useToast,
   Flex,
   FormControl,
   FormLabel,
   Input,
   InputGroup,
   Text,
   IconButton,
   InputRightElement,
   Divider,
   useDisclosure,
   Box,
   VStack,
   HStack,
   Icon,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FaArrowRight, FaBuilding, FaFileInvoice } from 'react-icons/fa';
import { MdBusiness } from 'react-icons/md';
import CompanyForm from './CompanyForm';
import { validateGST } from '../../../utils/util';

const validationSchema = Yup.object().shape({
   gst: Yup.string()
      .min(15, 'Name must be at least 15 characters long')
      .test('gst-valid', 'Invalid GST number', (value) => {
         if (!value) return false;
         return validateGST.isValid(value);
      })
      .optional(),
});

const CompanyWithGst = ({ isOpen, onClose }) => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const textColor = useColorModeValue('gray.800', 'white');
   const btnRef = React.useRef();
   const toast = useToast();
   const [gstNo, setGstNO] = useState(null);
   const [row, setRow] = useState({
      gst: '',
   });

   const { isOpen: isOpenModal, onOpen: onOpenModal, onClose: onCloseModal } = useDisclosure();

   const {
      register,
      handleSubmit,
      formState: { errors },
      reset,
   } = useForm({
      resolver: yupResolver(validationSchema),
      defaultValues: {
         gst: '',
      },
      mode: 'onChange',
   });

   const handleOnClose = () => {
      localStorage.removeItem('gst');
      onCloseModal();
   };

   const onSubmit = (data) => {
      setGstNO(data.gst);
      localStorage.setItem('gst', data.gst);
      onClose();
      onOpenModal();
      reset();
   };

   return (
      <>
         <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
            <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(10px)" />
            <ModalContent
               bg={
                  isDark
                     ? 'linear-gradient(135deg, #1a202c 0%, #2d3748 100%)'
                     : 'linear-gradient(135deg, #ffffff 0%, #f7fafc 100%)'
               }
               borderRadius="24px"
               boxShadow={isDark ? '0 25px 50px -12px rgba(0, 0, 0, 0.5)' : '0 25px 50px -12px rgba(0, 0, 0, 0.15)'}
               border="1px"
               borderColor={isDark ? 'whiteAlpha.200' : 'gray.200'}
               overflow="hidden"
               position="relative"
               _before={{
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '4px',
                  bgGradient: isDark
                     ? 'linear(to-r, blue.400, purple.500, pink.400)'
                     : 'linear(to-r, blue.500, purple.600, pink.500)',
               }}>
               {/* Header Section with Beautiful Gradient */}
               <Box
                  bg={
                     isDark
                        ? 'linear-gradient(135deg, #2b6cb0 0%, #4c51bf 100%)'
                        : 'linear-gradient(135deg, #ebf8ff 0%, #e6fffa 100%)'
                  }
                  borderBottom="3px"
                  borderColor={isDark ? 'blue.500' : 'blue.300'}
                  px={8}
                  py={6}
                  position="relative">
                  <HStack spacing={4} align="center">
                     <Box
                        bg={isDark ? 'whiteAlpha.200' : 'blue.100'}
                        p={3}
                        borderRadius="16px"
                        border="2px"
                        borderColor={isDark ? 'blue.400' : 'blue.300'}>
                        <Icon as={MdBusiness} boxSize={8} color={isDark ? 'blue.200' : 'blue.600'} />
                     </Box>
                     <VStack align="start" spacing={0}>
                        <ModalHeader
                           fontSize="26px"
                           fontWeight="700"
                           p={0}
                           color={isDark ? 'white' : 'gray.800'}
                           letterSpacing="tight">
                           Create New Company
                        </ModalHeader>
                        <Text fontSize="14px" color={isDark ? 'blue.200' : 'blue.700'} fontWeight="500">
                           Setup your business in seconds
                        </Text>
                     </VStack>
                  </HStack>
                  <ModalCloseButton
                     top={6}
                     right={6}
                     color={isDark ? 'white' : 'gray.700'}
                     bg={isDark ? 'whiteAlpha.200' : 'white'}
                     borderRadius="12px"
                     _hover={{
                        bg: isDark ? 'whiteAlpha.300' : 'gray.100',
                        transform: 'rotate(90deg)',
                     }}
                     transition="all 0.3s"
                  />
               </Box>

               <ModalBody px={8} py={8}>
                  {/* GSTIN Input Section with Card Style */}
                  <Box
                     bg={isDark ? 'linear-gradient(135deg, #2d3748 0%, #1a202c 100%)' : 'white'}
                     borderRadius="20px"
                     p={6}
                     border="2px"
                     borderColor={isDark ? 'blue.600' : 'blue.200'}
                     boxShadow={isDark ? '0 10px 30px rgba(0, 0, 0, 0.3)' : '0 10px 30px rgba(0, 0, 0, 0.05)'}
                     mb={6}
                     position="relative"
                     overflow="hidden"
                     _before={{
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        width: '4px',
                        bg: isDark ? 'blue.400' : 'blue.500',
                     }}>
                     <form onSubmit={handleSubmit(onSubmit)}>
                        <FormControl>
                           <HStack spacing={3} mb={3} align="center">
                              <Box bg={isDark ? 'blue.900' : 'blue.50'} p={2} borderRadius="10px">
                                 <Icon as={FaFileInvoice} color={isDark ? 'blue.300' : 'blue.600'} boxSize={5} />
                              </Box>
                              <FormLabel fontSize="15px" fontWeight="600" color={textColor} mb={0}>
                                 Quick Setup with GSTIN
                              </FormLabel>
                           </HStack>

                           <Text fontSize="13px" color={isDark ? 'gray.400' : 'gray.600'} mb={4} lineHeight="1.6">
                              Provide your Company's GSTIN and we'll automatically fetch all the details for you
                           </Text>

                           <InputGroup size="lg">
                              <Input
                                 isRequired
                                 fontSize="15px"
                                 name="gst"
                                 placeholder="Enter 15-digit GSTIN (e.g., 29ABCDE1234F1Z5)"
                                 size="lg"
                                 type="text"
                                 pr="4.5rem"
                                 {...register('gst')}
                                 sx={{ textTransform: 'uppercase' }}
                                 bg={isDark ? 'whiteAlpha.100' : 'gray.50'}
                                 border="2px"
                                 borderColor={errors.gst ? 'red.400' : isDark ? 'whiteAlpha.300' : 'gray.300'}
                                 color={textColor}
                                 borderRadius="14px"
                                 fontWeight="500"
                                 _hover={{
                                    borderColor: isDark ? 'blue.400' : 'blue.400',
                                 }}
                                 _focus={{
                                    borderColor: isDark ? 'blue.400' : 'blue.500',
                                    boxShadow: isDark
                                       ? '0 0 0 3px rgba(66, 153, 225, 0.2)'
                                       : '0 0 0 3px rgba(66, 153, 225, 0.1)',
                                    bg: isDark ? 'whiteAlpha.200' : 'white',
                                 }}
                                 transition="all 0.2s"
                              />
                              <InputRightElement width="4.5rem" height="100%">
                                 <IconButton
                                    colorScheme="blue"
                                    ref={btnRef}
                                    icon={<FaArrowRight />}
                                    type="submit"
                                    size="md"
                                    borderRadius="12px"
                                    mr={2}
                                    bg={
                                       isDark
                                          ? 'linear-gradient(135deg, #2b6cb0 0%, #4c51bf 100%)'
                                          : 'linear-gradient(135deg, #4299e1 0%, #667eea 100%)'
                                    }
                                    _hover={{
                                       transform: 'translateX(4px)',
                                       boxShadow: 'lg',
                                    }}
                                    transition="all 0.3s"
                                    aria-label="Submit GSTIN"
                                 />
                              </InputRightElement>
                           </InputGroup>

                           {errors.gst && (
                              <HStack
                                 mt={3}
                                 spacing={2}
                                 bg={isDark ? 'red.900' : 'red.50'}
                                 px={3}
                                 py={2}
                                 borderRadius="10px"
                                 border="1px"
                                 borderColor={isDark ? 'red.600' : 'red.200'}>
                                 <Text color="red.500" fontSize="13px" fontWeight="500">
                                    ⚠️ {errors?.gst?.message}
                                 </Text>
                              </HStack>
                           )}
                        </FormControl>
                     </form>
                  </Box>

                  {/* Divider Section with Modern Style */}
                  <Flex align="center" my={6} position="relative">
                     <Divider flex="1" borderColor={isDark ? 'whiteAlpha.300' : 'gray.300'} borderWidth="1px" />
                     <Box
                        px={4}
                        py={2}
                        bg={isDark ? 'whiteAlpha.100' : 'gray.100'}
                        borderRadius="20px"
                        border="1px"
                        borderColor={isDark ? 'whiteAlpha.300' : 'gray.300'}>
                        <Text
                           fontSize="13px"
                           fontWeight="600"
                           color={isDark ? 'gray.400' : 'gray.600'}
                           letterSpacing="wider">
                           OR
                        </Text>
                     </Box>
                     <Divider flex="1" borderColor={isDark ? 'whiteAlpha.300' : 'gray.300'} borderWidth="1px" />
                  </Flex>

                  {/* Manual Setup Section with Card Style */}
                  <Box
                     bg={isDark ? 'linear-gradient(135deg, #2d3748 0%, #1a202c 100%)' : 'white'}
                     borderRadius="20px"
                     p={6}
                     border="2px"
                     borderColor={isDark ? 'purple.600' : 'purple.200'}
                     boxShadow={isDark ? '0 10px 30px rgba(0, 0, 0, 0.3)' : '0 10px 30px rgba(0, 0, 0, 0.05)'}
                     position="relative"
                     overflow="hidden"
                     _before={{
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        width: '4px',
                        bg: isDark ? 'purple.400' : 'purple.500',
                     }}>
                     <HStack spacing={3} mb={3}>
                        <Box bg={isDark ? 'purple.900' : 'purple.50'} p={2} borderRadius="10px">
                           <Icon as={FaBuilding} color={isDark ? 'purple.300' : 'purple.600'} boxSize={5} />
                        </Box>
                        <Text fontSize="15px" fontWeight="600" color={textColor}>
                           Manual Setup
                        </Text>
                     </HStack>

                     <Text fontSize="13px" color={isDark ? 'gray.400' : 'gray.600'} mb={4} lineHeight="1.6">
                        Don't have GSTIN? No problem! You can setup your company manually and add GSTIN later.
                     </Text>

                     <Flex justify="center">
                        <Button
                           size="lg"
                           bg={
                              isDark
                                 ? 'linear-gradient(135deg, #6b46c1 0%, #805ad5 100%)'
                                 : 'linear-gradient(135deg, #9f7aea 0%, #b794f4 100%)'
                           }
                           color="white"
                           onClick={() => {
                              onOpenModal();
                              onClose();
                           }}
                           borderRadius="14px"
                           px={8}
                           fontWeight="600"
                           fontSize="14px"
                           letterSpacing="wide"
                           _hover={{
                              transform: 'translateY(-2px)',
                              boxShadow: 'xl',
                           }}
                           _active={{
                              transform: 'translateY(0)',
                           }}
                           transition="all 0.3s"
                           leftIcon={<FaBuilding />}>
                           SETUP WITHOUT GSTIN
                        </Button>
                     </Flex>
                  </Box>

                  {/* Info Footer */}
                  <Box
                     mt={6}
                     textAlign="center"
                     p={4}
                     bg={isDark ? 'whiteAlpha.50' : 'blue.50'}
                     borderRadius="14px"
                     border="1px"
                     borderColor={isDark ? 'whiteAlpha.200' : 'blue.100'}>
                     <Text fontSize="12px" color={isDark ? 'gray.400' : 'gray.600'} lineHeight="1.6">
                        💡 <strong>Pro Tip:</strong> Setting up with GSTIN saves time by auto-filling company details
                     </Text>
                  </Box>
               </ModalBody>
            </ModalContent>
         </Modal>

         <CompanyForm isOpen={isOpenModal} onClose={handleOnClose} isEditMode={false} currentRow={null} gstNo={gstNo} />
      </>
   );
};

export default CompanyWithGst;
